(() => {
  if (customElements.get('alleon-delivery-estimator')) return;
  const europe = new Set('AL AD AT BY BE BA BG HR CY CZ DK EE FI FR GE DE GR HU IS IE IT XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SE CH TR UA GB VA'.split(' '));
  function addWeekdays(iso, days) {
    const date = new Date(iso + 'T12:00:00Z');
    while (days > 0) { date.setUTCDate(date.getUTCDate() + 1); if (![0,6].includes(date.getUTCDay())) days--; }
    return date;
  }
  class DeliveryEstimator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-delivery-variants]').textContent);
      this.region = this.querySelector('[data-delivery-region]');
      this.result = this.querySelector('[data-delivery-result]');
      this.scope = this.closest('.product__section');
      this.region.value = this.dataset.country === 'DE' ? 'de' : europe.has(this.dataset.country) ? 'eu' : 'world';
      this.onChange = () => { this.update(); clearTimeout(this.timer); this.timer = setTimeout(() => this.update(), 500); };
      this.region.addEventListener('change', this.onChange);
      this.scope?.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(records => { if (records.some(r => !this.contains(r.target))) this.update(); });
      if (this.scope) this.observer.observe(this.scope, {subtree:true, childList:true, attributes:true, attributeFilter:['value','data-selected-variant-id']});
      this.onFocus = () => this.update();
      window.addEventListener('focus', this.onFocus);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); clearTimeout(this.timer);
      this.scope?.removeEventListener('change', this.onChange);
      this.region?.removeEventListener('change', this.onChange);
      window.removeEventListener('focus', this.onFocus);
      this.ready = false;
    }
    update() {
      const field = this.scope?.querySelector('.formVariantId');
      const id = field ? field.value : this.dataset.initial;
      const variant = this.variants.find(v => String(v.id) === String(id));
      this.hidden = !variant?.stock;
      if (this.hidden) return;
      const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const get = type => parts.find(p=>p.type===type).value;
      const today = `${get('year')}-${get('month')}-${get('day')}`;
      const range = this.region.value === 'de' ? [2,3] : this.region.value === 'eu' ? [3,5] : [7,7];
      const fmt = new Intl.DateTimeFormat(this.dataset.locale || 'en', {day:'numeric',month:'short',year:'numeric',timeZone:'UTC'});
      const dates = range[0] === range[1] ? `${this.dataset.approx} ${fmt.format(addWeekdays(today,7))}` : `${fmt.format(addWeekdays(today,range[0]))} – ${fmt.format(addWeekdays(today,range[1]))}`;
      const days = range[0] === range[1] ? `${this.dataset.approx} 7` : `${range[0]}–${range[1]}`;
      const text = `${dates} · ${days} ${this.dataset.days}`;
      if (this.result.textContent !== text) this.result.textContent = text;
    }
  }
  customElements.define('alleon-delivery-estimator', DeliveryEstimator);
})();
